import { Chip, createStyles, ListItem, makeStyles } from "@material-ui/core";
import { findRole, ROLE } from "../constants";
import useDANDEContext from "../utils/useDANDEUserContext";

const useStyles = makeStyles(
  createStyles({
    listItem: {
      borderTop: "1px solid #e0e0e0",
    },
    roles: {
      display: "flex",
      flexWrap: "wrap",
      width: "330px",
    },
    role: {
      margin: "2px",
    },
  })
);

const RolesDisplay = () => {
  const dandeContext = useDANDEContext();
  const classes = useStyles();

  const roles = [] as string[];

  if (!dandeContext?.roles) {
    // Not in SO register so do not display anything
    return null;
  }

  if (dandeContext.roles.complianceCoordinator) {
    roles.push(findRole(ROLE.COMPLIANCE_COORDINATOR)?.name);
  }
  if (dandeContext.roles.engineer) {
    roles.push(findRole(ROLE.ENGINEER)?.name);
  }
  if (dandeContext.roles.estimateReviewer) {
    roles.push(findRole(ROLE.ESTIMATE_REVIEWER)?.name);
  }
  if (dandeContext.roles.resourceManager) {
    roles.push(findRole(ROLE.RESOURCE_MANAGER)?.name);
  }
  if (dandeContext.roles.technicalReviewer) {
    roles.push(findRole(ROLE.TECHNICAL_REVIEWER)?.name);
  }
  if (dandeContext.roles.psgManager) {
    roles.push(findRole(ROLE.PSG_MANAGER)?.name);
  }

  if (roles.length === 0) {
    return null;
  }

  return (
    <ListItem className={classes.listItem} key="roles">
      <div className={classes.roles}>
        {roles.map((role) => (
          <Chip className={classes.role} key={role} label={role} />
        ))}
      </div>
    </ListItem>
  );
};

export default RolesDisplay;
